import { useHistory } from 'react-router-dom';

export const useHeaderNavigation = (course) => {
  const history = useHistory();

  const goToTeachersPage = () => {
    if (course) {
      history.push(`/courses/${course._id}/teachers`);
    }
  };

  return {
    goToTeachersPage,
  };
};
